export default __webpack_public_path__ + "c180866cbf276815e14e20c04f20dfa8.svg";